const title = "BAR CLASSICO";
const subtitle = "by Banilux";
const address = "2/8 Chapel Street, Off Commercial Avenue, Sabo, Lagos";
const guesthouseNumber = "2349135040637";

const menuIcons = {
  beer: "🍺",
  "energy drinks": "⚡",
  "soft drinks": "🥤",
  cocktails: "🍹",
  vodka: "🍸",
  rum: "🥃",
  tequila: "🍹",
  champagne: "🍾",
  "red wine": "🍷",
  "non alcoholic wine": "🍷",
  "cream liquor": "🥛",
  spirits: "🥃",
  aperitif: "🍸",
  whiskey: "🥃",
  cognac: "🥃",
  water: "💧",
  peppersoups: "🍲",
  meals: "🍛",
  "peppered meat": "🍖",
  shawarma: "🌯",
  grill: "🔥",
  "amala hut": "🍜",
  takeaway: "📦",
  default: "🍽️",
};

const guesthouseData = [
  {
    title: "Complimentary Services",
    backgroundColor: "#eb9b34",
    points: [
      "Satellite TV (9 Channels)",
      "Luggage Service",
      "Free Wi-Fi",
      "Complimentary Breakfast",
    ],
  },
  {
    title: "Check-In and Check-Out",
    backgroundColor: "#251896",
    points: [
      "Payment validates reservation",
      "Check-in: 2:00 PM",
      "Guests must inform the front desk 1 hour before check-out if extending stay",
      "Guaranteed early check-in requires full room rate payment",
    ],
  },
  {
    title: "Guest Policies",
    backgroundColor: "#96183e",
    points: [
      "No smoking in rooms (attracts ₦10,000 fine)",
      "Guests may smoke in the bar area",
      "No pets allowed",
      "Prohibited items: firearms, explosives, inflammables, radioactive materials, illegal drugs",
      "Loss/Damage: Guests must pay for any loss or damage to guesthouse property",
      "Leave keycard at the reception when leaving",
      "Lost or damaged keycard incurs ₦20,000 charge",
    ],
  },
  {
    title: "Contact Details",
    backgroundColor: "#1b5e20",
    points: ["Front Desk: 09135040637, 08169444534", "Room Service: Dial 108"],
  },
];

export {
  title,
  subtitle,
  address,
  guesthouseNumber,
  menuIcons,
  guesthouseData,
};
